import React, { useState, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, TextField, Typography } from '@vivaahealth/design-system';

import styles from './index.module.css';

import * as api from '../../../api';

import { parseValue } from 'common/dist/utils/types';

const { AuthErrorType } = api.Previsit;

interface Props {
  code?: string;
  backToContactPage: () => void;
  login: () => Promise<void>;
  setCode: (code?: string) => void;
}

const Otp: React.FC<Props> = ({ backToContactPage, setCode, login, code }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation('login');
  const handleLogin = async () => {
    setIsSubmitting(true);
    try {
      await login();
      window.scrollTo(0, 0);
    } catch (err) {
      let errorMessage = 'Does not match, try again.';
      const loginError = parseValue<{ message: string }>(err.message);
      if (loginError?.message === AuthErrorType.MaxAttempts) {
        errorMessage = 'Max login attempts reached.';
      }
      setErrorMessage(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };
  const onEnterLogin = async (e: KeyboardEvent) => {
    if (e.code === 'Enter') await handleLogin();
  };
  return (
    <>
      <div className={styles['description-container']}>
        <Typography variant="paragraph-large">
          {t('sixDigitCodeSentPrompt')}
        </Typography>
      </div>
      <div className={styles['text-field-container']}>
        <TextField
          autoFocus
          className={errorMessage && styles['text-field-error']}
          placeholder={t('sixDigitCodePrompt')}
          onChange={(e) => {
            setErrorMessage('');
            setCode(e.target.value);
          }}
          inputMode="numeric"
          maxLength={6}
          onKeyDown={onEnterLogin}
        />
        <Typography
          variant="title-medium"
          className={styles['text-field-subtitle-error']}
        >
          {t(errorMessage)}
        </Typography>
        <Button
          className={styles['resend-code']}
          size="small"
          variant="text"
          onClick={() => backToContactPage()}
        >
          {t('resendCodeOption')}
        </Button>
      </div>
      <Button
        disabled={!code || isSubmitting || !!errorMessage}
        fullWidth
        size="medium"
        onClick={async () => await handleLogin()}
      >
        {isSubmitting
          ? t('checking', { input: 'code' })
          : t('submit', { ns: 'common' })}
      </Button>
    </>
  );
};

export default Otp;
